title: Broker Search
noResults: No yachts found for these filters.
addToProposal: Add to Proposal
removeFromProposal: Remove from Proposal
invalidProposalArea: This yacht does not charter in this proposal's destination.
filterAndSort: Filter & Sort
backToSearch: Back to Search
moreMenu:
  edit: Edit Yacht Listing
  report: Report Problem with Listing
filter:
  resetAll: Reset All Filters
  showCountYachts_zero: No yachts match
  showCountYachts_one: Show {{ count }} Yacht
  showCountYachts_other: Show {{ count }} Yachts
  group:
    dates: Dates
    categoryAndHull: Type & Hull
    price: Price
    launchAndRefit: Launch & Refit
    dimensions: Dimensions
    guestsAndCabins: Guests & Cabins
    keywords: Keywords
  date:
    reset: Reset Calendar
    mode:
      date: Dates
      season: Season
  dateFlexibility:
    exact: Exact Dates
    days_one: ± {{ count }} day
    days_other: ± {{ count }} days
  category:
    nullLabel: All Types
  hull:
    nullLabel: All Hulls
    monohull: Monohull
    multihull: Multihull
  keywords:
    group:
      amenities: Amenities
      toys: Toys
      diving: Diving
order:
  'tier,-dateListed': Suggested
  'lowPrice': Lowest price
  '-lowPrice': Highest price
  'guestsSleeping': Least guests
  '-guestsSleeping': Most guests
  'lengthMeters': Shortest
  '-lengthMeters': Longest
  'yearLaunch': Oldest
  '-yearLaunch': Newest
yacht:
  price:
    low: Weekly low
    high: Weekly high
  seasons:
    lowPrice: Low season
    highPrice: High season
    availableAreas_one: Available in 1 destination
    availableAreas_other: Available in {{ count }} destinations
  details:
    centralAgent:
      contact: Contact Agent
    specification:
      title: Specification
      dimensions: Dimensions
      construction: Construction
      performance: Performance
      accommodation: Accommodation
    accommodation:
      title: Accommodation
    features:
      title: Features
      amenities: Amenities
      toys: Toys
      diving: Diving
      tenders: Tenders
    crew:
      title: Crew
    specialOffer:
      title: Special Offer
    rates:
      title: Rates
      additionalExclusions: Additional exclusions are {{ exclusions }}
    calendar:
      title: Calendar
      pickup: Pickup
      dropOff: Drop off
      details: Details
    position:
      title: Location
      lastSeen: Last seen in {{ locationName }} on {{ date }}
    layout:
      title: Layout
  report:
    label: Report a Problem with this Yacht
    issueType:
      label: What is the issue?
      INACCURATE: The listing is inaccurate and needs updating.
      CONTACT: The Central Agency or contact is not correct.
      UNAVAILABLE: The yacht is no longer on the charter market.
    placeholder:
      INACCURATE: What information is inaccurate in the listing?
      CONTACT: Who is the new Central Agency and / or contact for this yacht?
      UNAVAILABLE: Why is the yacht no longer available?
    notification:
      failure:
        title: Something went wrong submitting your report.
        message: Our team has been notified.
      success: Thank you! Your report has been submitted.
  disclaimer:
    - The details provided above for {{ yachtName }} are displayed in good faith and whilst believed to be correct are not guaranteed. Charter Index does not warrant or assume any legal liability or responsibility for the accuracy, completeness, or usefulness of any information and/or images displayed.
    - Please check the accuracy of yacht specifications, photographs and rates during your charter yacht selection process with {{ companyName }} direct.
    - All information is subject to change without notice and is without warranty.
proposal:
  title: Proposal
  buttonLabel:
    add: Add {{ yachtName }} to proposal
    remove: Remove {{ yachtName }} from proposal
    full: Proposal full
  selectionCount: '{{ count }} / {{ max }} yachts selected'
  clearSelection: Clear Selection
  createProposal: Create Proposal
  editProposal: Edit Proposal
  notification:
    add: '{{ yachtName }} added'
    remove: '{{ yachtName }} removed'
    clear: Proposal cleared
    full: Maximum yacht selection reached
permissionDenied:
  title: You do not have an active broker subscription
  message: In order to access the charter broker system, you need to have an active subscription.
  cta: Purchase Subscription
textSearchDescription:
  destination: Search for destinations, builders, central agents, and yachts.
  noDestination: Search for builders, central agents, and yachts.
